import { baseApiRoutes } from '../../core/config/apiRoutes';

export const apiRoutes = {
  ...baseApiRoutes,
  publicAuth: {
    emailRegister: 'auth/public/email/register',
    googleLogin: 'auth/public/google/login',
    verifyUser: 'auth/public/email/verify',
  },
  support: {
    createTicket: 'help',
  },
  vocabularyItem: {
    list: 'vocabulary-item',
    all: 'vocabulary-item/all',
    create: 'vocabulary-item',
    update: 'vocabulary-item/:id',
    delete: 'vocabulary-item/:id',
  },
  clients: {
    list: 'clients',
    get: 'clients/:id',
    profile: 'clients/profile',
    create: 'clients',
    update: 'clients/:id',
    delete: 'clients/linked/:id',
    createLinkedAdmin: 'clients/:id/linked',
    createLinkedSelf: 'clients/linked',
    updateProfile: 'clients/profile',
    linkedClients: 'clients/linked',
  },
  invoices: {
    get: 'invoices/:id',
    getInvoicePreview: 'invoices/:id/preview',
    list: 'invoices',
  },
  plans: {
    getCurrent: 'plans/current',
    getInfo: 'plans/info',
    purchase: 'plans/purchase',
    cancel: 'plans/cancel',
  },
  document: {
    list: 'documents',
    create: 'documents',
    get: 'documents/:id',
    update: 'documents/:id',
    delete: 'documents/:id',
    setMistakes: 'documents/:id/mistakes',
  },
  grammarProcess: {
    process: 'grammar-process/process',
  },
};
